{
  "leads.nav": "Leads",
  "leads.subtitle": "Enquiries from the website and the ones you add. Answer them fast, qualify them, and turn the good ones into projects.",
  "leads.side.label": "Inbox at a glance",
  "leads.loadError": "We could not load the leads.",
  "leads.overviewError": "We could not load the inbox numbers.",
  "leads.loadMore": "Show more leads",
  "leads.loadingMore": "Loading…",
  "leads.search": "Search leads",
  "leads.filter.service": "Service",
  "leads.filter.anyService": "Every service",
  "leads.tabs.label": "Leads by stage",
  "leads.view.label": "View",
  "leads.view.board": "Board",
  "leads.view.list": "List",
  "leads.board.column": "{column}, {count, plural, one {# lead} other {# leads}}",
  "leads.board.empty": "No leads here. Drag one in.",
  "leads.board.picked": "Picked up {name}.",
  "leads.board.over": "{name} is over {column}.",
  "leads.board.dropped": "{name} dropped on {column}.",
  "leads.board.cancelled": "Moving {name} was cancelled.",
  "leads.state.new": "New",
  "leads.state.contacted": "Contacted",
  "leads.state.cold": "Cold",
  "leads.state.warm": "Warm",
  "leads.state.qualified": "Qualified",
  "leads.state.meeting_done": "Meeting done",
  "leads.state.converted": "Converted",
  "leads.state.lost": "Lost",
  "leads.state.all": "All",
  "leads.source.consultation": "Consultation request",
  "leads.source.message": "Contact message",
  "leads.source.manual": "Added by the team",
  "leads.new.open": "New lead",
  "leads.new.title": "New lead",
  "leads.new.description": "For a lead that came by phone, WhatsApp or a referral. It starts in New and is yours until you reassign it.",
  "leads.new.name": "Name",
  "leads.new.company": "Company (optional)",
  "leads.new.phone": "Phone",
  "leads.new.phoneHint": "A local number is read as Egyptian; add the country code for others.",
  "leads.new.email": "Email",
  "leads.new.service": "Service",
  "leads.new.serviceUnknown": "Not sure yet",
  "leads.new.budget": "Budget (optional)",
  "leads.new.budgetPlaceholder": "e.g. 50,000 EGP",
  "leads.new.message": "What they need",
  "leads.new.messagePlaceholder": "What they asked for, and anything worth remembering from the call.",
  "leads.new.submit": "Add lead",
  "leads.new.saving": "Adding…",
  "leads.new.added": "{name} added to New",
  "leads.new.errors.name": "Enter the lead's name.",
  "leads.new.errors.email": "Enter a valid email address.",
  "leads.new.errors.phone": "Enter a phone number we can read, with its country code for non-Egyptian numbers.",
  "leads.new.errors.reach": "Add a phone number or an email, so the team can answer them.",
  "leads.new.errors.tooLong": "This is too long.",
  "leads.kpi.newThisWeek": "New this week",
  "leads.kpi.total": "{count, plural, one {# lead in total} other {# leads in total}}",
  "leads.kpi.uncontacted": "Waiting over 24h",
  "leads.kpi.uncontactedCaption": "New and not answered yet",
  "leads.kpi.allAnswered": "All answered",
  "leads.kpi.conversion": "Conversion rate",
  "leads.kpi.conversionCaption": "{count} of {total, plural, one {# decided lead} other {# decided leads}} won",
  "leads.kpi.conversionEmpty": "No lead won or lost yet",
  "leads.kpi.response": "Median first response",
  "leads.kpi.responseEmpty": "No lead answered yet",
  "leads.kpi.goalMet": "Within the 2-hour goal",
  "leads.kpi.goalMissed": "Slower than the 2-hour goal",
  "leads.duration.minutes": "{minutes}m",
  "leads.duration.hoursMinutes": "{hours}h {minutes}m",
  "leads.duration.daysHours": "{days}d {hours}h",
  "leads.pipeline.title": "Pipeline",
  "leads.pipeline.description": "Every lead by stage",
  "leads.sync.now": "Sync now",
  "leads.sync.running": "Syncing…",
  "leads.sync.last": "Synced {when}",
  "leads.sync.never": "Not synced yet",
  "leads.sync.notConfigured": "Website not connected",
  "leads.sync.done": "{count, plural, one {# new lead from the website} other {# new leads from the website}}",
  "leads.sync.upToDate": "The inbox is up to date.",
  "leads.row.noService": "Service not given",
  "leads.row.owner": "Owner: {name}",
  "leads.row.cold": "Waiting over 24 hours",
  "leads.actions.whatsapp": "WhatsApp {name}",
  "leads.actions.call": "Call {name}",
  "leads.empty.title": "No leads yet",
  "leads.empty.body": "Enquiries from the website's consultation and contact forms land here. Sync to pull the latest.",
  "leads.empty.new.title": "Nothing new",
  "leads.empty.new.body": "Every lead has been picked up. New enquiries appear here first.",
  "leads.empty.contacted.title": "No conversations open",
  "leads.empty.contacted.body": "Leads you have answered wait here until they are qualified or lost.",
  "leads.empty.cold.title": "No cold leads",
  "leads.empty.cold.body": "Leads that went quiet or are not ready yet wait here until they warm up.",
  "leads.empty.warm.title": "No warm leads",
  "leads.empty.warm.body": "Leads showing real interest wait here until they qualify.",
  "leads.empty.qualified.title": "No qualified leads",
  "leads.empty.qualified.body": "Leads that fit, with a budget and a need, are ready to become projects.",
  "leads.empty.meeting_done.title": "No meetings done",
  "leads.empty.meeting_done.body": "Leads you have met wait here for the proposal and the decision.",
  "leads.empty.converted.title": "No conversions yet",
  "leads.empty.converted.body": "Leads you turn into projects are kept here, linked to their client and project.",
  "leads.empty.lost.title": "Nothing lost",
  "leads.empty.lost.body": "Lost leads keep their reason, so the agency learns what it loses to.",
  "leads.empty.all.title": "No leads yet",
  "leads.empty.all.body": "Enquiries from the website's consultation and contact forms land here.",
  "leads.noResults.title": "No lead matches",
  "leads.noResults.body": "Try another name, number or service.",
  "leads.noResults.clear": "Clear filters",
  "leads.sheet.label": "Lead",
  "leads.sheet.received": "Received {when}",
  "leads.sheet.loadError": "We could not load this lead",
  "leads.sheet.loadErrorBody": "Check your connection and try again.",
  "leads.sheet.message": "Their message",
  "leads.sheet.budget": "Budget",
  "leads.sheet.contact": "Contact",
  "leads.sheet.convertedTitle": "Converted into {key}",
  "leads.sheet.convertedBody": "Client: {client}",
  "leads.sheet.openProject": "Open project",
  "leads.field.phone": "Phone",
  "leads.field.whatsapp": "WhatsApp",
  "leads.field.email": "Email",
  "leads.field.language": "Language",
  "leads.field.owner": "Owner",
  "leads.field.noOwner": "Nobody yet",
  "leads.field.received": "Received",
  "leads.field.none": "Not given",
  "leads.matches.title": "Existing clients",
  "leads.matches.description": "Clients with a contact on the same phone or email",
  "leads.matches.none": "No client has this phone or email. It looks like a new client.",
  "leads.matches.phone": "Phone",
  "leads.matches.email": "Email",
  "leads.notes.title": "Notes",
  "leads.notes.placeholder": "What did they say? What happens next?",
  "leads.notes.saved": "Notes saved",
  "leads.triage.label": "Stage",
  "leads.triage.moved": "Moved to {status}",
  "leads.lost.title": "Mark the lead as lost",
  "leads.lost.description": "Why did it not go ahead? The reason helps the agency see what it loses to.",
  "leads.lost.reason": "Reason",
  "leads.lost.confirm": "Mark as lost",
  "leads.lostReason.budget": "Budget too small",
  "leads.lostReason.timing": "Not the right time",
  "leads.lostReason.no_response": "Stopped answering",
  "leads.lostReason.competitor": "Went with someone else",
  "leads.lostReason.not_a_fit": "Not a fit for us",
  "leads.lostReason.spam": "Spam or a test",
  "leads.lostReason.closed_on_website": "Closed on the website",
  "leads.lostReason.other": "Another reason",
  "leads.remote.pendingTitle": "The website does not know yet",
  "leads.remote.retry": "Retry sync",
  "leads.remote.synced": "The website is up to date.",
  "leads.convert.open": "Convert to project",
  "leads.convert.title": "Convert to a project",
  "leads.convert.description": "Creates the client, the contact and the project for {name} in one step, and closes the lead on the website.",
  "leads.convert.clientSection": "Client",
  "leads.convert.clientMode": "Who is the client?",
  "leads.convert.newClient": "A new client",
  "leads.convert.newClientHint": "Add them with this lead as the main contact",
  "leads.convert.existingClient": "An existing client",
  "leads.convert.existingHint": "Add the project to a client we already have",
  "leads.convert.existingMatched": "{count, plural, one {# client matches this lead} other {# clients match this lead}}",
  "leads.convert.client": "Client",
  "leads.convert.clientPlaceholder": "Choose a client",
  "leads.convert.matched": "Matches this lead",
  "leads.convert.clientName": "Client name",
  "leads.convert.country": "Country",
  "leads.convert.language": "Language",
  "leads.convert.projectSection": "Project",
  "leads.convert.submit": "Create client and project",
  "leads.convert.working": "Converting…",
  "leads.convert.done": "Project {key} created",
  "leads.convert.errors.clientName": "Name the client (at least 2 characters).",
  "leads.convert.errors.client": "Choose the client.",
  "leads.convert.errors.clientTaken": "A client with this name exists. Choose it as an existing client.",
  "leads.errors.alreadyConverted": "This lead is already a project.",
  "leads.errors.notFound": "This lead no longer exists.",
  "leads.errors.notConfigured": "The website is not connected yet. Ask an admin to set the lead sync key.",
  "leads.errors.unavailable": "We could not reach the website. Try again in a minute.",
  "leads.errors.conflict": "Someone else changed this lead. It has been refreshed."
}
